import { scrollToSection } from "@/components/landing/Nav";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-gold/15 bg-ink py-16">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="flex flex-col items-start justify-between gap-10 md:flex-row md:items-center">
          <div className="flex items-center gap-4">
            <img src="/assets/logo.png" alt="AB Hunter Consulting USA logo" className="h-14 w-auto object-contain" />
            <div>
              <p className="font-display text-lg font-semibold">AB Hunter Consulting USA</p>
              <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-gold">Building Bridges · Elevating Communities · Transforming Leaders</p>
            </div>
          </div>
          <nav className="flex flex-wrap gap-x-7 gap-y-2 text-sm text-muted-foreground" aria-label="Footer">
            {[["About", "about"], ["Services", "services"], ["Events", "events"], ["Shop", "shop"], ["Contact", "contact"]].map(([label, id]) => (
              <button key={id} data-testid={`footer-link-${id}`} onClick={() => scrollToSection(id)} className="transition-colors hover:text-gold">
                {label}
              </button>
            ))}
            <a href="/admin/login" data-testid="footer-admin-link" className="transition-colors hover:text-gold">Admin</a>
          </nav>
        </div>
        <div className="mt-12 flex flex-col items-start justify-between gap-4 border-t border-gold/10 pt-8 text-xs text-muted-foreground sm:flex-row sm:items-center">
          <p>© {new Date().getFullYear()} AB Hunter Consulting USA · engage@abhunter.us · 225.603.4116</p>
          <p>
            Site built and managed by{" "}
            <a href="https://sitelytic.io" target="_blank" rel="noopener noreferrer" data-testid="footer-sitelytic-link" className="text-gold hover:underline">
              Sitelytic.io
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
